import React from 'react';
//import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import './index.scss';
import './traductor';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';

let deferredPrompt;
let installPromptReadyCallback;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  if (installPromptReadyCallback) installPromptReadyCallback(); // Avisamos a App
});

export const onInstallPromptReady = (callback) => {
  installPromptReadyCallback = callback;
};

export const promptInstall = async () => {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    deferredPrompt = null;
    return outcome;
  }
  return null;
};

// React 18: createRoot en vez de ReactDOM.render
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>    
  </Provider>,
  //document.getElementById('root')
);

// Registro del service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[SW] Registrado con scope:', registration.scope);

        // Aquí ya puedes acceder a pushManager
        return registration.pushManager.getSubscription();
      })
      .then((subscription) => {
        console.log('[SW] Subscripción actual:', subscription);
      })
      .catch((error) => {
        console.error('[SW] Error al registrar:', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
